export default class custSerRefferalPage {
    constructor() {
        
    }
}
